import style from "./DisplayGrid.module.scss";

export default function DisplayGrid({ children, col, colMobile, colTablet, gap, className = "", style: inlineStyle }) {
  const gapStyle = gap != null ? { gap: `${gap}px`, ...inlineStyle } : inlineStyle;

  return (
    <div
      grid-col={col}
      grid-gap={gap}
      grid-col-mobile={colMobile}
      grid-col-tablet={colTablet}
      className={`${className} ${style.DisplayGrid}`}
      style={gapStyle}
    >
      {children}
    </div>
  );
}